const Settings = () => <div>Settings here</div>;

export default Settings;
